import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { colors, fonts } from "../theme";
import { View, Text, Button, Press, ScreenHeader, SectionTitle } from "../ui";
import { Icon } from "../Icon";
import { useI18n } from "../i18n";
import { useAuth } from "../auth";
import { useAppState } from "../state";

const DICE = (seed) => `https://api.dicebear.com/7.x/thumbs/png?seed=${seed}&backgroundColor=b6e3f4,c0aede,d1d4f9,ffd5dc,ffdfbf`;
const PHOTO = "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?crop=entropy&cs=srgb&fm=jpg&q=85&w=300";
const AVATARS = [PHOTO, DICE("Melly"), DICE("Zurich"), DICE("Leader"), DICE("Aria"), DICE("Nova"), DICE("Sky"), DICE("Ivy"), DICE("Max")];

export default function Profile() {
  const navigate = useNavigate();
  const { tr } = useI18n();
  const { user } = useAuth();
  const { state, setProfile } = useAppState();
  const [name, setName] = useState(state.profile.name ?? user?.name ?? "");
  const [motto, setMotto] = useState(state.profile.motto ?? "");
  const [avatar, setAvatar] = useState(state.profile.avatar ?? AVATARS[0]);
  const [savedFlag, setSavedFlag] = useState(false);

  const save = () => {
    setProfile({ name: name.trim(), motto: motto.trim(), avatar });
    setSavedFlag(true);
    setTimeout(() => navigate(-1), 500);
  };

  const input = { backgroundColor: colors.surfaceSecondary, border: `1px solid ${colors.border}`, borderRadius: 14, padding: "0 16px", height: 52, fontWeight: fonts.medium, fontSize: 15, color: colors.onSurface, width: "100%" };

  return (
    <View style={{ flex: 1, minHeight: "100vh", backgroundColor: colors.surfaceSecondary }}>
      <ScreenHeader title={tr("editProfile")} onBack={() => navigate(-1)} />
      <View style={{ padding: "20px 20px 120px" }}>
        <View style={{ alignItems: "center", marginBottom: 20 }}>
          <img alt="" src={avatar} style={{ width: 96, height: 96, borderRadius: 48, objectFit: "cover", backgroundColor: colors.surfaceTertiary }} />
        </View>
        <SectionTitle>{tr("chooseAvatar")}</SectionTitle>
        <View row style={{ flexWrap: "wrap", gap: 12, marginBottom: 20 }}>
          {AVATARS.map((a, idx) => {
            const sel = a === avatar;
            return (
              <Press key={a} testID={`avatar-${idx}`} onClick={() => setAvatar(a)} style={{ borderRadius: 34, border: `3px solid ${sel ? colors.brandPrimary : "transparent"}`, padding: 2, position: "relative" }}>
                <img alt="" src={a} style={{ width: 58, height: 58, borderRadius: 29, objectFit: "cover", backgroundColor: colors.surfaceTertiary, display: "block" }} />
                {sel && (
                  <View style={{ position: "absolute", bottom: 0, right: 0, width: 22, height: 22, borderRadius: 11, backgroundColor: colors.brandPrimary, alignItems: "center", justifyContent: "center", border: `2px solid ${colors.surface}` }}>
                    <Icon name="check" size={12} color={colors.onBrandPrimary} weight="bold" />
                  </View>
                )}
              </Press>
            );
          })}
        </View>
        <SectionTitle>{tr("displayName")}</SectionTitle>
        <input data-testid="profile-name" value={name} onChange={(e) => setName(e.target.value)} placeholder="Melly" style={{ ...input, marginBottom: 20 }} />
        <SectionTitle>{tr("mottoLabel")}</SectionTitle>
        <textarea data-testid="profile-motto" value={motto} onChange={(e) => setMotto(e.target.value)} placeholder={tr("motto")} style={{ ...input, height: 80, paddingTop: 14, resize: "none" }} />
      </View>
      <View style={{ position: "sticky", bottom: 0, padding: 20, backgroundColor: colors.surface, borderTop: `1px solid ${colors.divider}` }}>
        <Button testID="profile-save" title={savedFlag ? tr("saved") : tr("save")} icon={savedFlag ? "check" : "check-circle"} onPress={save} disabled={!name.trim()} />
      </View>
    </View>
  );
}
